import { i18n } from '@/lang/index.js'

const wordsMap = {
  coins: () => {
    return i18n.t('lang.OtherModule.k004')
  },
}

export default wordsMap
